module.exports = require('./lib/Sizes');



//////////////////
// WEBPACK FOOTER
// ./~/react-sizes/index.js
// module id = 834
// module chunks = 0